var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"dense":""}},_vm._l((_vm.areas),function(area){return _c('v-col',{key:area.name,attrs:{"cols":_vm.grid}},[_c('pro-d-chart',{attrs:{"stats":area}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }